import { RiAddCircleLine } from 'react-icons/ri';
import { Box, Button, Flex, Icon, useStyleConfig } from '@chakra-ui/react';
import { handleAdd } from '../../handlers';

const AddMore = ({props, newPart}) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  const navSection =
    props.navSections[props.stateProps.sectionData.sectionName];
  return (
    <>
      <Box w="100%">
        <Flex sx={{ justifyContent: 'flex-end' }}>
          <Button

            sx={{ ...buttonStyles.secondary, ...buttonStyles.newResume }}
            onClick={() => handleAdd(formikProps, stateProps, newPart)}
          >
            <Icon as={RiAddCircleLine} />
            &nbsp;Additional {navSection.more}
          </Button>
        </Flex>
      </Box>
    </>
  );
};
export default AddMore;

/*
See counselor notes modal

          <Button
          onClick={() =>stateProps.onNotesModalOpen()}
          >??</Button>
 */
